import { lazy } from "react";

export default {
  name: "WorkPhone",
  path: "/workPhone",
  component: lazy(() => import("./index"))
}